import Estate from './Estate';
import Service from './Service';


export default {
  Estate,
  ProductService: Service,
};
